import React from 'react'
// import {Image} from 'cloudinary-react'
import SlideWrapper from './slideWrappers/SlideWrapper'
import BodyWrapper from './slideWrappers/BodyWrapper'
import ChoicesWrapper from './slideWrappers/ChoicesWrapper'
import ImageWrapper from './slideWrappers/ImageWrapper'
import StaticLetterBlock from './StaticLetterBlock'
import {isSurvey} from '../../utils/isSurvey'
 
//Fallback slide is used when there are no saved font sizes


class FallbackStaticQuestionSlide extends React.PureComponent{

	constructor(){
		super()
		this.updateFontSizes=this.updateFontSizes.bind(this)
		this.onMouseEnterChoice=this.onMouseEnterChoice.bind(this)
		this.onMouseEnterChoicesGroup=this.onMouseEnterChoicesGroup.bind(this)
		this.onMouseLeaveChoicesGroup=this.onMouseLeaveChoicesGroup.bind(this)
		this.state={		
			choicesFontSize:0
		}
	}	
	
	onMouseEnterChoice(choiceLetter){
		if(this.props.onMouseEnterChoice){
			this.props.onMouseEnterChoice(choiceLetter)
		}
	}

	onMouseEnterChoicesGroup(){
		if(this.props.onMouseEnterChoicesGroup){
			this.props.onMouseEnterChoicesGroup()
		}
	}
	onMouseLeaveChoicesGroup(){
		if(this.props.onMouseLeaveChoicesGroup){
			this.props.onMouseLeaveChoicesGroup()
		}
	}

	updateFontSizes(field,newFontSize){
		this.setState({choicesFontSize:newFontSize})
	}

	render(){
		const {choicesGroupHovered,isLiveView,showResponseCounts,expectedResponses,template,colorScheme,alwaysShowLetterblock,question,displayWidth,isReviewScreen, reportView,showCorrect,showGraph,processedResponses, isScanScreen, isAskScreen, totalResponses} = this.props
		const scale=displayWidth/1280

		const letterArray=['A','B','C','D']
		const isSurveyQuestion=isSurvey(question)
		return(
			<SlideWrapper displayWidth={displayWidth} isStatic={true} template={template} key={question.id} reportView={reportView}>
	
				<BodyWrapper template={template} question={question} scale={scale} isStaticSlide={true} choicesFontSize={this.state.choicesFontSize}>
					<div className='slide-body'>
						{question.body}		
					</div>																		
				</BodyWrapper>

				<ImageWrapper template={template} image={question.image}/>
		

				<ChoicesWrapper template={template} choicesGroupHovered={choicesGroupHovered} question={question} scale={scale} isStaticSlide={true} updateFontSizes={this.updateFontSizes}>
					<div className={'slide-choices ' + (choicesGroupHovered ? ' slide-choices--delayHovered':' slide-choices--notDelayHovered')} onMouseEnter={this.onMouseEnterChoicesGroup} onMouseLeave={this.onMouseLeaveChoicesGroup}>
						{question.choices.map(function (choice,key) {
								let graphPercentageWidth
								let responseCount=0	
							if(processedResponses){
								let graphScaling=totalResponses
								if(isLiveView){
									graphScaling=expectedResponses
								}
								graphPercentageWidth = processedResponses[`responsesAnswer${letterArray[key]}`].length / graphScaling * 100
								responseCount = processedResponses[`responsesAnswer${letterArray[key]}`].length
								}
										let displayGraph=false
										let displaySyncGraph= false
										if(showGraph){
											displayGraph = true
											displaySyncGraph = true
										}
										else if(reportView){
											displayGraph = true									
										}

										

    					return(
	    						<div onMouseEnter={()=>{this.onMouseEnterChoice(letterArray[key])}}  className={`slide-choice choice--${key}` + (choice.correct ? ' is--correct' : ' isNot--correct') + (colorScheme ? ` is--${colorScheme} `: '') + (isSurveyQuestion ? ' is--survey' : ' isNot--survey') + (isReviewScreen ? ' is--review' : ' ') + (isAskScreen ? ' is--ask' : ' isNot--ask ') + (showCorrect ? ' is--showCorrect' : ' isNot--showCorrect') + (isScanScreen ? ' is--scan': ' isNot--scan')  + (showResponseCounts ? ' is--showResponseCounts ': ' isNot--showResponseCounts ') + (displaySyncGraph ? ' is--displaySyncGraph ': ' isNot--displaySyncGraph ')} key={key}>
	    							<StaticLetterBlock 
	    								index={key}	    								
	    								isReviewScreen={isReviewScreen}
	    								reportView={reportView}
	    								showCorrect={showCorrect}
	    								isCorrect={choice.correct}
	    								alwaysShowLetterblock={alwaysShowLetterblock}
	    								isSurvey={isSurveyQuestion}
	    							/>	    
	    						<div className="slide-choice-textContainer">					 				
					 				<div ref='test' className='slide-choice-text'>
					 					{choice.body}
					 				</div>
					 			</div>
					 			{displayGraph &&
					 				<div className='slide-choice-graph'>			 				
					 					<div style={{width: `${graphPercentageWidth}%` }} className='slide-choice-graph-bar' />
					 				</div>
					 			}
					 			{displayGraph && showResponseCounts &&
					 				<div className={'slide-choice-responseCount ' + (responseCount === 0 ? 'slide-choice-responseCount--isZero' : '')}>
					 					{responseCount}
					 				</div>
							 	}
								</div>
							)}.bind(this))}
					</div>
				</ChoicesWrapper>
			</SlideWrapper>	
		)
	}
}


FallbackStaticQuestionSlide.defaultProps = {
	displayWidth: 1280,

}


//<div style={{width : `calc(${0.5} * 100%)` }} className='slide-choice-graph-bar' />


export default FallbackStaticQuestionSlide